import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { LockOutlined as LockIcon } from '@mui/icons-material';
import OpenCashRegisterModal from '../location/sales/cash_register/OpenCashRegisterModal';

/**
 * Igual que Ventas: sin caja abierta no se opera. Muestra que la caja está cerrada y permite abrirla desde acá
 * (si hay terminal configurada en esta computadora).
 */
const CashClosedNotice = ({ locationId, terminalId, state, onOpened, onRetry }) => {
  const [openModal, setOpenModal] = useState(false);

  const content = {
    no_terminal: {
      title: 'Esta computadora no tiene una terminal configurada',
      text: 'Configurá una terminal de esta sucursal para poder abrir la caja y operar las mesas.',
    },
    unknown: {
      title: 'No pudimos verificar la caja',
      text: 'Revisá tu conexión e intentá de nuevo.',
    },
  }[state] || {
    title: 'La caja está cerrada',
    text: 'Abrí la caja para poder abrir mesas y tomar pedidos.',
  };

  // Misma estructura que el estado vacío de Ventas: ocupa toda la altura y centra el contenido (algo por encima del medio).
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: 420, marginBottom: '150px' }}>
          <LockIcon sx={{ fontSize: 56, color: 'text.secondary' }} />
          <Typography variant="h6" color="textSecondary">{content.title}</Typography>
          <Typography variant="body2" color="textSecondary">{content.text}</Typography>
          {state === 'closed' && terminalId && (
            <Button variant="contained" onClick={() => setOpenModal(true)}>
              Abrir caja
            </Button>
          )}
          {state === 'unknown' && (
            <Button variant="outlined" onClick={onRetry}>
              Reintentar
            </Button>
          )}
        </Stack>
      </Box>

      <OpenCashRegisterModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        locationId={locationId}
        terminalId={terminalId}
        onSuccess={onOpened}
      />
    </Box>
  );
};

export default CashClosedNotice;